<template>
	<div :class="['property-input', { 'clear-option': showClearButton, 'user-matching-option': isUserMatching, 'pad-content': showIcon }]">
		<!-- pass $attrs to child means pass all attributes of component that arent explicit declare as props -->
		<div v-if="showIcon" class="w-[25px] h-[25px] grid rounded-lg shadow-md border border-[#DFE4EF] prefix-icons">
			<v-img class="place-self-center" :src="icon" :width="15" />
		</div>
		<RichTextBox v-on="$listeners" v-bind="$attrs" readonly :ref="RICH_EDITOR_REFERENCE_NAME" />
		<div class="suffix-icons display-flex flex-row">
			<v-btn
				v-if="isUserMatching"
				text
				outlined
				class="ml-3 options-btn"
				width="105"
				height="24"
				:readonly="readonly"
				color="primary"
				style="right: 0px; top: 0px"
				@click="openUserMatchingDialog"
			>
				Edit options
			</v-btn>
			<AppTooltip :disabled="isTooltipDisabled" top text="Delete">
				<AnemicButton class="clear-btn mr-2" @click="clearValue" v-show="showClearButton && !readonly && $attrs.value">
					<v-icon class="clear-btn-icon">mdi-close</v-icon>
				</AnemicButton>
			</AppTooltip>
			<span v-if="!readonly" @click="$emit('click')">
				<DropdownArrowSvg class="dropdown-icon" :class="{ 'dropdown-open': isDropdownOpen }" />
			</span>
		</div>
	</div>
</template>

<script>
import DropdownArrowSvg from './assets/DropdownArrowSvg';
import InputComponentMixinBase from './mixins/InputComponentMixinBase';
import AppTooltip from '@/components/common/AppTooltip';
export default {
	name: 'DefaultPropertyDropdownInput',
	mixins: [InputComponentMixinBase],
	components: {
		AppTooltip,
		DropdownArrowSvg,
	},
	props: {
		isUserMatching: { type: Boolean },
		showClearButton: { type: Boolean },
		isDropdownOpen: { type: Boolean },
		readonly: { type: Boolean },
		icon: { type: String },
	},
	computed: {
		showIcon() {
			return !!this.icon;
		},
	},
	methods: {
		clearValue() {
			this.$emit('clear-value');
		},
		openUserMatchingDialog() {
			this.$emit('open-user-matching-dialog');
		},
	},
	data() {
		return {
			isTooltipDisabled: false,
		};
	},
	watch: {
		showClearButton(newV) {
			this.isTooltipDisabled = !newV;
		},
	},
};
</script>
<style lang="scss" scoped>
.property-input {
	position: relative;
	.prefix-icons {
		position: absolute;
		top: 6px;
		left: 9px;
		z-index: 1;
	}
	.suffix-icons {
		position: absolute;
		top: calc(50% - 3px); // 0px;;
		right: 10px;
		z-index: 1;
		.options-btn {
			font-weight: 400 !important;
			font-size: 14px !important;
			border-radius: 2px !important;
			border-color: currentColor !important;
		}
		.clear-btn,
		.clear-btn:focus,
		.clear-btn:hover {
			width: 20px;
			height: 20px;
			padding: 0px;
			border-radius: 10px !important;
			background: var(--clear-button-background);
			margin-top: -6px;

			.clear-btn-icon {
				font-size: medium;
			}
		}
		.dropdown-icon {
			transition: 0.2s transform;
			&.dropdown-open {
				transform: rotateX(180deg);
			}
		}
	}

	&.clear-option {
		::v-deep {
			.ProseMirror {
				padding-right: 70px;
			}
		}
	}
	&.user-matching-option {
		::v-deep {
			.ProseMirror {
				padding-right: 190px;
			}
		}
	}
	&.pad-content {
		::v-deep {
			.ProseMirror {
				padding-left: 40px;
			}
		}
	}
}
</style>
